import { CoursesService } from "@/common/api.service";
import { FETCH_COURSES, FETCH_INDIVIDUAL_COURSE,DELETE_COURSE, ADD_COURSE, UPDATE_COURSE, COURSE_RESET_STATE } from "./actions.type";
import { SET_COURSES, SET_COURSE_ERROR, RESET_COURSE_STATE, SET_INDIVIDUAL_COURSE} from "./mutations.type";

const initialState = () => {
    return {
        courses: [],
        individualcourse:{},
        courseerrors: {},
    }
}

let state = initialState()

const getters = {
    courses(state) {
        return state.courses
    },
    individualcourse(state) {
        return state.individualcourse
    }
}

const actions = {
    async [FETCH_COURSES](context, slug) {
        const { data } = await CoursesService.get(slug)
        context.commit(SET_COURSES, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_COURSE](context, slug) {
        const { data } = await CoursesService.get(slug)
        context.commit(SET_INDIVIDUAL_COURSE, data.data)
        return data;
    },    
    async [UPDATE_COURSE](context, payload) {
        return await CoursesService.update(payload)
        .then(({ data }) => {
          context.commit(SET_INDIVIDUAL_COURSE, data.data)  
          return data
        })
        .catch(error => {
          context.commit(SET_COURSE_ERROR, error.response.data.errors);
        });
    }, 
    async [ADD_COURSE](context, params) {
        return await CoursesService.create(params)
            .then(({ data }) => {
                return data
            })
            .catch(error => {
                context.commit(SET_COURSE_ERROR, error.response.data.errors);
            });
    },
    async [DELETE_COURSE](context, slug) {
        return await CoursesService.delete(slug)
            .then(({ data }) => {
                return data
            })
            .catch(error => {
                context.commit(SET_COURSE_ERROR, error.response.data)
            });
    },
    [COURSE_RESET_STATE]({ commit }) {
        commit(RESET_COURSE_STATE);
    }
}

const mutations = {
    [SET_COURSE_ERROR](state, error) {
        state.courseerrors = error;
    },
    [SET_INDIVIDUAL_COURSE](state, coursedata) {
        state.individualcourse = coursedata
    },
    [SET_COURSES](state, coursedata) {
        state.courses = coursedata;
    },
    [RESET_COURSE_STATE](state) {
        Object.assign(state, initialState())
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};

